const updateScroll = (parallaxRef, { props: { offset }}) =>
	parallaxRef.current.scrollTo(offset);

export default updateScroll;
